<template>
  <div>
    <div>
        <el-dialog
          title="我要还款"
          :visible.sync="dialogVisible"
          :modal="false"
          width="25%"
          :before-close="handleClose">
          <span>输入姓名、身份证号码进行查询债务信息</span>
          <el-form :model="form" class="form_box" :rules="rules" ref="ruleForm" v-if="!information" style="padding:20px">
            <el-form-item label="姓名" :label-width="formLabelWidth" prop="names">
              <el-input v-model="form.names" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" :label-width="formLabelWidth" prop="carId">
              <el-input v-model="form.carId" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="手机号" :label-width="formLabelWidth" prop="mobile">
              <el-input v-model="form.mobile" autocomplete="off"></el-input>
          </el-form-item>
          

          <el-form-item  :label-width="formLabelWidth">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm',form)">立即2查询</el-button>
          </el-form-item>
        </el-form>
        <div v-else style="display: flex; flex-direction: column; align-items: center;">
          <img style="padding:20px" src="./../../assets/img/img-zanwu.png" alt="">
          <span>无欠款信息</span>
          <el-button style="width:200px;margin:20px" @click="again">重新查询</el-button>
        </div>
        </el-dialog>
      </div>
    <banner></banner>
    <!-- <div>
      <div class="login-logos">
        <img src="../../assets/img/img-logo.png" alt />
      </div>
      <div v-if="indexStatus" @click="imgShow()" class="login-yasuo">
        <img src="../../assets/img/img-daohang.png" alt />
      </div>
      <div v-else @click="imgHide()" class="login-yasuo">
        <img src="../../assets/img/img-guanbi01.png" alt />
      </div>
      <el-row :class="{'menu_banner' : indexStatus==1}">
        <el-col class="menu_left">
          <el-menu :default-active="$route.path" router class="el-menu-demo" mode="vertical">
            <el-menu-item index="/index">
              首页
              <p>Home</p>
            </el-menu-item>
            <el-menu-item index="/introduce">
              业务介绍
              <br />Business Introductio
            </el-menu-item>
            <el-menu-item index="/consultation">
              资讯中心
              <br />Information Center
            </el-menu-item>
            <el-menu-item index="/about">
              关于扬海
              <br />About us
            </el-menu-item>
            <el-menu-item index="/contact">
              联系我们
              <br />Contact us
            </el-menu-item>
          </el-menu>
        </el-col>
      </el-row>
    </div> -->
    <!-- <div class="login-logos">
      <img src="../../assets/img/img-logo.png" alt />
    </div>
    <div v-if="indexStatus" @click="imgShow()" class="login-yasuo">
      <img src="../../assets/img/img-daohang.png" alt />
    </div>
    <div v-else @click="imgHide()" class="login-yasuo">
      <img src="../../assets/img/img-guanbi01.png" alt />
    </div>-->
    <div class="login-title" :class="{'login-titles' : indexStatus==1}">
      <img src="../../assets/img/img-title.png" alt />
    </div>
    <div class="login-biaotou" :class="{'login-biaotous' : indexStatus==1}">
      <p>向下滚动</p>
      <img src="../../assets/img/biaotou3.png" alt />
    </div>

    <el-row class="menu_img">
      <el-col class="img_left">
        <!-- <div class="login-logo">
          <img src="../../assets/img/img-01.png" alt />
          <div class="panment_btn">
            <el-button size="medium" @click="repaymentCommon()">我要还款 ⇀</el-button>
          </div>
        </div> -->
      </el-col>
    </el-row>
    <div class="conter-bom">
      <div class="page_spirit_top">
        <span class="page_spirit_top_span1">扬海精神</span>
        <span class="page_spirit_top_span2">/ Corporate Spirit</span>
      </div>
      <div class="page_spirit_bom">
        <div class="page_spirit_bom_left">
          <div>
            <p>公司秉承“扬帆起航，海纳百川”的企业宗旨</p>
            <p>面向全国，立足长远，致力于成为行业领先的不良资产服务平台</p>
          </div>
        </div>
        <el-row type="flex" align="middle">
          <el-col :span="10">
            <div class="page_spirit_bom_img">
              <div class="page_spirit_bom_flex">
                <img src="../../assets/img/ico-gaoxiao.png" alt />
                <span>专业</span>
              </div>
              <div class="page_spirit_bom_border"></div>
              <div class="page_spirit_bom_flex">
                <img src="../../assets/img/ico-gaoxiao.png" alt />
                    <span>创新</span>
              </div>
              <div class="page_spirit_bom_border"></div>
              <div class="page_spirit_bom_flex">
                <img src="../../assets/img/ico-gaoxiao.png" alt />
                    <span>诚信</span>
              </div>
            </div>
          </el-col>
          <el-col :span="14">
            <div class="page_spirit_bom_yanghai">
              <img src="../../assets/img/img-yanghai03.png" alt />
            </div>
          </el-col>
        </el-row>

        <div class="page_spirit_bom_right"></div>

        <div class="page_spirit_top">
          <span class="page_spirit_top_span1">关于扬海</span>
          <span class="page_spirit_top_span2">/ About</span>
        </div>
        <div class="page_spirit_bom_writing">
          我司是专注于金融不良资产投资、收购、管理和处置的综合性资产管理公司。公司秉承“扬帆起航，海纳百川”的企业宗旨，立足杭州，面向全国，致力于成为行业领先的特殊机会投资集团。通过市场化手段收购金融机构及类金融机构的抵押类和信用类不良资产，并采用非诉清收、诉讼清收、司法调解、司法拍卖、债务重组、资产置换、债转股、资产证券化等手段，对不良资产进行阶段化经营和管理，并利用大数据、人工智能、云平台、区块链等前沿科技和创新手段，布局资产评估、贷后管理、智能清收等应用领域。
        </div>
        <div class="page_spirit_bom_btn">
          <el-button>联系我们 ⇀</el-button>
        </div>
        <div class="page_spirit_bom_zimu">
          <img src="../../assets/img/img-zimu02.png" alt />
        </div>
      </div>
      <div class="page_spirit_bom_right"></div>

      <div class="right_bottom_new">
        <div class="notice_left">
          <div class="notice_img">
            <img src="./../../assets/img/ico-gonggao.png" alt />
            <span>公告通知</span>
          </div>
          <div class="notice_border_new"></div>
          <div class="notice_date1">08_</div>
          <div class="notice_date2">07 / 2019</div>
          <div class="notice_title">关于召开董事会会议的通知关于召开董事会会</div>
        </div>
        <div class="notice_right_new">
          <div class="notice_date1">12_</div>
          <div class="notice_date2">07 / 2019</div>
          <div class="notice_title">关于召开董事会会议的通知</div>
        </div>
        <div class="notice_right_new">
          <div class="notice_date1">03_</div>
          <div class="notice_date2">02 / 2019</div>
          <div class="notice_title">近段时间以来，中美贸易战及后续中兴受美国钳制</div>
        </div>
      </div>
      <div class="page_spirit_bom_right"></div>

      <div class="right_bottom_code">
        <div class="notice_right">
          <div class="notice_right_phone">400-800-1271</div>
          <div class="notice_right_title">扬海资产客户专线</div>
          <div class="notice_right_border"></div>
          <div class="notice_right_data1">service</div>
          <!-- <div class="notice_right_data2">9:00 - 20:00（7*10小时）</div> -->
        </div>
        <div class="notice_right">
          <div class="notice_right_phone">9:00 - 20:00</div>
          <div class="notice_right_title">客服在线时间</div>
          <div class="notice_right_border"></div>
          <div class="notice_right_data1">service</div>
          <!-- <div class="notice_right_data2">9:00 - 20:00（7*10小时）</div> -->
        </div>
      </div>
      <div class="notice_content_code">
        <img src="./../../assets/img/img-code01.png" alt />
        <div class="notice_content_guanzhu">
          <span>关注我们</span>
          <p>了解更多公司信息及还款方式</p>
        </div>
      </div>
    </div>
    <div class="comFooterMobile">
      <comFooterMobile />
    </div>
  </div>
</template>
<script>
import comFooterMobile from "@/components/page/comFooterMobile.vue"; //脚部
import banner from "@/components/page/banner.vue"; //脚部
export default {
  components: {
    comFooterMobile,
    banner
  },
  data() {
     const mobileValid = (rule, value, callback) => {
      if (value === '') {
          callback(new Error(' '));
        } else if (!(/^1[3456789]\d{9}$/.test(value))) {
          callback(new Error(' '));
        } else {
          callback();
        }
    };
    const carIdValid = (rule, value, callback) => {
      const p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (value === '') {
          callback(new Error(' '));
        } else if (!p.test(value)) {
          callback(new Error(' '));
        } else {
          callback();
        }
    };
    return {
      indexStatus: 1,
      dialogVisible: false,
      information: false,
      form: {
          names: '',
          carId: '',
          mobile: '',
        },
        formLabelWidth: '70px',
        rules: {
          names: [
            { required: true, message: ' ', trigger: 'change' },
            { min: 2, max: 15, message: ' ', trigger: 'change' }
          ],
          mobile: [
            { validator: mobileValid, required: true, trigger: 'change' },
          ],
          carId: [
            { validator: carIdValid, required: true, trigger: 'change' },
          ],
        }
    };
  },

  methods: {

    handleClose(){
      let that = this;
      that.dialogVisible = false;
    },
    repaymentCommon(){
      let that = this;
      that.dialogVisible = true;
    },
    again(){
      let that = this;
      that.information = false;
    },
    submitForm(formName,form) {
      console.info(formName,form)
      let that = this;
      // that.ajaxJson({
      //   url: "/websiteManage/contentListss",
      //   data:{
      //     carId: form.carId,
      //     page:1,
      //     size:10
      //   },
      //   success: function(data) {
      //     if (data.code == "0000") {
      //       // that.$router.push({path:'paymentDetail'}) // 只能用 name
      //       that.$router.push({name:'paymentDetail',params:data}) // 只能用 name
      //     }
      //   }
      // });
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.ajaxJson({
            url: "/website/findInfoByCarId?carId=" + form.carId,
            method: 'GET',
            // data:{
            //   type: 1
            // },
            success: function(data) {
              if (data.code == "0000" && data.data == true) {
                that.information = false;
                 that.ajaxJson({
                    url: "/website/authClears",
                    data:{
                      carId: form.carId,
                      page:1,
                      size:10,
                    },
                    success: function(data) {
                      if (data.code == "0000") {
                        that.$router.push({name:'paymentDetail',params:data}) // 只能用 name
                      }
                    }
                  });
              }else{
                that.information = true;
              }
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // imgShow() {
    //   this.indexStatus = 0;
    // },
    // imgHide() {
    //   this.indexStatus = 1;
    // }
  }
};
</script>
<style>
/* 屏幕可视窗口尺寸大于 480  */
@media screen and (min-width: 300px) and (max-width: 480px) {
  .index-page .lefts {
    width: 100%;
    overflow: auto;
  }
  .el-dialog__body .form_box{
    padding: 20px;
  }
  .menu_banner {
    display: none;
  }
  .menu_left {
    padding-bottom: 500px;
  }
  .login-yasuo {
    display: inline-block !important;
    position: absolute;
    top: 35px;
    right: 35px;
  }
  .login-yasuo img {
    width: 48px;
  }
  .login-titles {
    display: block !important;
  }
  .login-titles img {
    width: 300px;
    padding: 0 92px;
    display: block;
  }

  .login-biaotous {
    display: flex !important;
    flex-direction: column;
    align-items: center;
    color: #fff;
    padding: 300px 0;
  }
  .login-biaotous img {
    width: 40px;
  }
  .conter-bom {
    background: #fff;
    padding: 0 90px;
    display: block !important;
  }
  .conter-bom .page_spirit_bom_right {
    margin: 51px 0;
    height: 1px;
    width: auto;
  }
  .conter-bom .page_spirit_bom_zimu img {
    width: 96%;
  }
  .conter-bom .page_spirit_bom_writing {
    width: auto;
  }
  .conter-bom .right_bottom_new {
    width: auto;
    display: block;
    padding-bottom: 0;
  }
  .conter-bom .right_bottom_new .notice_img {
    padding: 20px 0;
  }
  .conter-bom .notice_right_new {
    padding: 30px 0;
    display: block !important;
  }
  .conter-bom .right_bottom_new .notice_date1 {
    margin: 0;
  }
  .conter-bom .right_bottom_new .notice_title {
    margin: 0;
  }
  .conter-bom .right_bottom_code {
    padding: 0;
    width: auto;
    justify-content: space-between;
  }
  .conter-bom .notice_content_code {
    padding: 100px 0;
    margin: 0 !important;
    display: flex;
  }
  .conter-bom .notice_content_code .notice_content_guanzhu {
    margin: auto;
  }
  .menu_img {
    display: none;
  }
  .comFooterMobile{
  display: block!important;
}
}

.comFooterMobile{
  display: none;
}
.menu_left .el-menu {
  border-right: none;
  background-color: transparent;
}
.menu_left .el-menu .el-menu-item {
  color: #ffffff !important;
  width: 480px;
  height: 110px;
  padding-top: 20px;
  font-size: 18px;
  padding-left: 60px !important;
}
.el-menu-item.is-active {
  background-color: rgba(255, 255, 255, 0.1) !important;
}
.el-submenu__title:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}
.el-menu-item:hover {
  background: rgba(255, 255, 255, 0.1) !important;
}
.menu_left .el-menu-item,
.el-submenu__title {
  line-height: 26px;
  font-size: 12px;
}
.img_left {
  text-align: right;
}
.img_left .login-logo {
  position: relative;
}
.img_left img {
  background-size: cover;
  width: 400px;
  height: 195px;
  padding-top: 100px;
}
.login-logos {
  text-align: center;
  padding: 45px 0 25px 80px;
  display: inline-block;
}
.login-yasuo {
  display: none;
}
.login-title {
  display: none;
}
.login-biaotou {
  display: none;
}
.conter-bom {
  display: none;
}
.login-logos img {
  background-size: cover;
  width: 314px;
  height: 50px;
  margin-bottom: 165px;
}
.panment_btn {
  position: absolute;
  top: 215px;
  left: 110px;
}
.panment_btn .el-button {
  background-color: transparent;
  color: #fff;
  font-size: 12px;
  width: 170px;
  height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/indexLeft.vue